<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div [class.isPrinting]="printService.isPrinting">


  <div class="job-posts placements agreements margin-top-service-30px">
    <div class="card my-profile-form skillassest-form">



    </div>
    <div class="card-body padding-top padding-left-0px padding-bottom-0px padding-right-0px">
      <div class="row">
        <div class="col-md-3 padding-right-0px colmd3">
          <div class="position-fixed-scans border-right2 padding-right-5px height-100pe">
            <div class="card height-100pe">

              <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
                <div class="row margin-top10px margin-left-20px  nav-link-hand">
                  <div class="col-md-10 padding-left-0px">
                    <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                      Cryo Preservation
                    </label>
                  </div>


                  <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

                    <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
                  </div>-->


                  <div class="col-md-1">
                    <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
                  </div>
                  <!--<a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                  *ngIf="ShowIcon"><i class="fas fa-angle-double-left font-size-19px"></i></a>-->

                </div>




              </div>
              <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
                <div class="row border-top margin-left-0px margin-right-0px">
                  <div class="col-md-5 col-sm-4 padding-right-0px my-profile-form margin-left-10px">
                    <div class="date-form margin-top-5px form-group margin-bottom-0px">
                      <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>



                  </div>
                  <div class="col-md-1 " (click)="DecrementDate()">
                    <a title="Previous" class="nav-link-hand">
                      <i class="fas fa-caret-left margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                  <div class="col-md-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                    <a title="Next" class="nav-link-hand">
                      <i class="fas fa-caret-right margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                </div>
                <div class="row margin-right-0px margin-left-0px">
                  <div class="col-md-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                    <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
                  </div>
                  <div class="col-md-2" hidden>
                    <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Edit">
                      <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                    </a>

                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Delete">
                      <span class="badge font-size-14">
                        <i class="far fa-trash-alt"></i>
                      </span>
                    </a>
                  </div>

                </div>
                <div>
                  <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps scroll padding-lrt " data-ps-id="dfsfsde">

                    <!--<div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                      <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                        <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                      </div>
                      <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="margin-bottom-0px">Ramya santhosh</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>
                    <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                      <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                        <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                      </div>
                      <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="margin-bottom-0px">Ramya santhosh</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>-->
                    <div *ngIf="isRequesting">
                      <div class="loader-text">
                        <div class="loader-text2">

                          <div class="lds-facebook">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                          <div class="margin-top-20px margin-left-5px">
                            <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                          </div>
                          <!--Loading Please Wait...-->
                        </div>
                      </div>
                      <!--<div class="loadernew"></div>-->


                    </div>
                    <div *ngIf="!isRequesting">
                      <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient(l)" *ngFor="let l of pdata">
                        <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient(l)">
                          <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.OwnerPatientImageFile" onError="this.src='dummy.jpg';">



                        </div>
                        <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.OwnerName}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerAgeYears}} years,{{l.OwnerFormattedCode}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-4">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerTelephone1}}</label>
                            </div>
                          </div>

                        </div>
                        <div class="col-md-3 padding-left-0px margin-top-5px">
                          <div class="text-align-center">
                            <a data-toggle="tooltip" data-placement="bottom" title="Completed" *ngIf="l.ActivityStatus=='Completed'">

                              <i class="fas fa-check-circle color-icon-completed font-size-16px">
                              </i>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="Initiated" *ngIf="l.ActivityStatus=='Initiated'">

                              <i class="fas fa-check-circle color-gray font-size-16px">
                              </i>
                            </a>
                          </div>
                          <div class="text-align-center"><label class="font-size-12px">{{l.LastUpdatedTime | date: 'hh:mm a'}}</label></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div class="col-md-9 " *ngIf="ScanDetails">

          <div class="row">
            <div class="col-md-12 padding-left-0px">
              <div class="card">
                <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px">
                  <div class="row">
                    <div class="col-md-1 ">
                      <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.EggPatientImageFile" onError="this.src='dummy.jpg';">
                    </div>
                    <div class="col-md-4">
                      <div class="row row-height-17px margin-left-0px">
                        <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.EggName}} </label>
                      </div>
                      <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>
                      <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>-->

                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggAgeYears}},{{SelectedpatientDetails.EggFormattedCode}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggTelephone1}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-7  padding-right-0px">
                      <div class="row font-size-12px">
                        <div class="col-md-9 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
                        </div>:
                        <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="SemanAnalysis2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{SemanAnalysis2.LastUpdatedTime | date: 'hh:mm a'}}</label>
                        </div>
                      </div>
                      <div class="row font-size-12px">
                        <div class="col-md-9 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
                        </div>:
                        <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="SemanAnalysis2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{SemanAnalysis2.ActivityStatus}}</label>
                        </div>
                      </div>
                      <div class="row margin-right-0px" hidden>
                        <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
                        </div>
                        <div class="Dsa2" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
                        </div>
                        <div class="Dsa3 margin-right-5pe" *ngIf="DSADetails">

                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-right-0px padding-top-0px padding-bottom-0px">
                  <div class="card margin-right-54px">
                    <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px bk-color-light">
                      <div class="row nav-link-hand margin-right-0px" id="edit-link">
                        <div class="col-md-6 padding-right-0px">
                          <label class="margin-bottom-0px font-size-16px font-weight-normal">
                            Cryo Preservation
                          </label>
                        </div>
                        <div class="col-md-5  padding-right-0px ">
                          <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                          <div class="row float-right" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture' && SelectedpatientDetails.TCModelName!='Fet'">
                            <!--<div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2 && SelectedpatientDetails.GradingModel=='Well Culture'">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                            </div>-->
                            <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Freezing Completed</a>
                              <!--<a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheckDrop()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed' || SelectedpatientDetails.GradingModel=='Droplet Culture'">Is Grading Completed</a>-->
                            </div>

                            <div class="col-md-1" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printgrading()" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>
                          </div>

                          <div class="row float-right" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.TCModelName!='Fet'">
                            <!--<div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2 && SelectedpatientDetails.GradingModel=='Well Culture'">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                            </div>-->
                            <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                              <!--<a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed' || SelectedpatientDetails.GradingModel=='Well Culture'">Is Grading Completed</a>-->
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Freezing Completed</a>
                            </div>
                            <div class="col-md-1">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printcryodroplet()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>

                            <!--<div class="col-md-1" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printgradingdroplet()" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>-->
                          </div>
                          <div class="row float-right" *ngIf="SelectedpatientDetails.TCModelName=='Fet' && SelectedpatientDetails.GradingModel=='Well Culture' ">
                            <!--<div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2 && SelectedpatientDetails.GradingModel=='Well Culture'">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                            </div>-->
                            <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                              <!--<a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed' || SelectedpatientDetails.GradingModel=='Well Culture'">Is Grading Completed</a>-->
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheckDrop()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Freezing Completed</a>
                            </div>

                            <div class="col-md-1">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printfet()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>
                            <!--<div class="col-md-1" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printgradingdroplet()" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>-->
                          </div>
                          <div class="row float-right" *ngIf="SelectedpatientDetails.TCModelName=='Fet' && SelectedpatientDetails.GradingModel=='Droplet Culture' ">
                            <!--<div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2 && SelectedpatientDetails.GradingModel=='Well Culture'">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                            </div>-->
                            <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                              <!--<a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed' || SelectedpatientDetails.GradingModel=='Well Culture'">Is Grading Completed</a>-->
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheckDrop()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Freezing Completed</a>
                            </div>

                            <div class="col-md-1">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printfet()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>
                            <!--<div class="col-md-1" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printgradingdroplet()" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>-->
                          </div>

                        </div>

                      </div>
                    </div>

                    <div class="card-body padding-right-0px padding-left-0px padding-top-0px">
                      <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps overflow-x-hidden padding-lrt " data-ps-id="dfsfsde">

                        <div class="accordion padding-top-10" id="accordionExample6">
                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSix">
                              <div class="row">
                                <div class="col-md-4">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                      Embryo Storage Table
                                    </button>
                                  </h5>
                                </div>
                                <div class="col-md-7 padding-right-0px" *ngIf="Frozen">

                                  <button class="btn actions-btn-prime float-right font-size-15px " type="button" (click)="AddEmbryotostore()" *ngIf="Frozen > 0">
                                    Store Selected Embryos
                                  </button>

                                </div>
                                <!--<div class="col-md-7 padding-right-0px">
                                  <ng-container *ngFor="let l of CurrentFollicularScanOvaryDetailController">
                                    <ng-template  *ngIf="l.SelectedFreezeCount > 0">
                                      <button class="btn actions-btn-prime float-right font-size-15px " type="button" (click)="AddEmbryotostore()">
                                        Store Selected Embryos
                                      </button>
                                    </ng-template>

                                  </ng-container>
                                </div>-->
                              </div>


                            </div>

                            <div id="collapseSix" class="collapse show" aria-labelledby="headingSix" data-parent="#accordionExample">
                              <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="table-component">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero width-100pe">

                                          <thead class="">
                                            <tr>
                                              <!--<th class="min-width-0px padding-right-0px padding-left-0px"></th>-->
                                              <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Sno</th>
                                              <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Cycle Details </th>-->
                                              <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px">DOC</th>

                                              <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">Date</th>
                                              <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>
                                              <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Stage</th>
                                              <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Frozen Count</th>
                                              <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Can Freeze Count</th>


                                              <!--<th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                              <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->

                                              <th class="padding-top-4px padding-bottom-4px font-size-12px">Select For Storage</th>


                                            </tr>
                                          </thead>
                                          <tbody class="table-body">

                                            <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleController ; let RowIndex = index ">

                                              <!--<td class="padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"> <input type="checkbox" class="width-15px "></td>-->
                                              <td class="padding-top-4px padding-bottom-4px">{{RowIndex+1}}</td>
                                              <!--<td class="padding-top-4px padding-bottom-4px"></td>-->
                                              <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px text-align-center">
                                                {{l.DOC}}

                                              </td>
                                              <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">

                                                {{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}
                                              </td>
                                              <td class="padding-top-4px padding-bottom-4px"><label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label></td>

                                              <td class="padding-top-4px padding-bottom-4px">
                                                <label class="margin-bottom-0px" *ngIf="l.DOC!=='3'">{{l.CellStage}}</label>
                                                <label class="margin-bottom-0px" *ngIf="l.DOC=='3'">{{l.CellCount}}</label>
                                              </td>
                                              <td class="padding-top-4px padding-bottom-4px text-align-center"> {{l.NetFrozenCount}}</td>
                                              <td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}} </td>
                                              <!--<td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}}</td>-->
                                              <td class="padding-top-4px padding-bottom-4px">

                                                <input *ngIf="l.AvailableCount>0"
                                                       type="checkbox" class="width-30px height-14px margin-top-3px display-inline" (ngModelChange)="dataChanged2($event,l)"
                                                       [(ngModel)]="l.IsSelected" />
                                                <i class="input-helper"></i>

                                                <input type="text" class="form-control-patient width-34pe display-inline" placeholder=""
                                                       [(ngModel)]="l.SelectedFreezeCount" [value]='Frozen' (keyup)="onKey(l.SelectedFreezeCount)"
                                                       name="l.SelectedFreezeCount" #Frozen="ngModel"
                                                       maxlength="100" required *ngIf="l.IsSelected">
                                                <label *ngIf="l.SelectedFreezeCount>l.AvailableCount" class="margin-bottom-0px">Error:</label> <label *ngIf="l.SelectedFreezeCount>l.AvailableCount" class="color-Rejected margin-bottom-0px margin-left-3px margin-top-3px">Reduce Selected Count</label>

                                              </td>
                                            </tr>
                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>



                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="accordion padding-top-10" id="accordionExample">
                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                              <div class="row">
                                <div class="col-md-4">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                      Current Cycle
                                    </button>
                                  </h5>
                                </div>

                              </div>


                            </div>

                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                              <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="table-component">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero width-100pe">

                                          <thead class="">
                                            <tr>
                                              <!--<th class="min-width-0px padding-right-0px padding-left-0px"></th>-->
                                              <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Sno</th>
                                              <th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Cycle Details </th>
                                              <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">DOC</th>
                                              <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">Date</th>
                                              <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>


                                              <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Stage</th>
                                              <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Embryo Count</th>
                                              <!--<th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                              <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                              <!--<th class="padding-top-4px padding-bottom-4px font-size-12px">Select</th>-->


                                            </tr>
                                          </thead>
                                          <tbody class="table-body">

                                            <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferrablesController ; let RowIndex = index ">
                                              <!--<td class="padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"> <input type="checkbox" class="width-15px "></td>-->
                                              <td class="padding-top-4px padding-bottom-4px">{{RowIndex+1}}</td>
                                              <td class="padding-top-4px padding-bottom-4px">{{l.CycleNumber}}</td>
                                              <td class="padding-top-4px padding-bottom-4px padding-left-0px text-align-center">
                                                {{l.DOC}}

                                              </td>
                                              <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">

                                                {{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}
                                              </td>

                                              <td class="padding-top-4px padding-bottom-4px"><label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label></td>
                                              <td class="padding-top-4px padding-bottom-4px">
                                                <label class="margin-bottom-0px" *ngIf="l.DOC!=='3'">{{l.CellStage}}</label>
                                                <label class="margin-bottom-0px" *ngIf="l.DOC=='3'">{{l.CellCount}}</label>
                                              </td>
                                              <td class="padding-top-4px padding-bottom-4px text-align-center">{{l.EmbryoCount}}</td>

                                              <!--<td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}}</td>-->
                                              <!--<td class="padding-top-4px padding-bottom-4px"><button class="btn actions-btn-prime font-size-13px margin-right-auto" (click)="SelectPresentstep1(l)">Select</button></td>-->
                                            </tr>
                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>



                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="accordion" id="accordionExample2">
                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingtwo">
                              <div class="row">
                                <div class="col-md-4">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsetwo" aria-expanded="true" aria-controls="collapsetwo">
                                      Previous Cycles
                                    </button>
                                  </h5>
                                </div>

                              </div>


                            </div>

                            <div id="collapsetwo" class="collapse show" aria-labelledby="headingtwo" data-parent="#accordionExample2">
                              <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="table-component">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero width-100pe">

                                          <thead class="">
                                            <tr>
                                              <!--<th class="min-width-0px padding-right-0px padding-left-0px"></th>-->
                                              <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Sno</th>
                                              <th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Cycle Details </th>
                                              <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">DOC</th>
                                              <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">Date</th>
                                              <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>


                                              <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Stage</th>
                                              <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Embryo Count</th>
                                              <!--<th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                              <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                              <!--<th class="padding-top-4px padding-bottom-4px font-size-12px">Select</th>-->


                                            </tr>
                                          </thead>
                                          <tbody class="table-body">

                                            <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferrablesControllerByActor ; let RowIndex = index ">
                                              <!--<td class="padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"> <input type="checkbox" class="width-15px "></td>-->
                                              <td class="padding-top-4px padding-bottom-4px">{{RowIndex+1}}</td>
                                              <td class="padding-top-4px padding-bottom-4px">{{l.CycleNumber}}</td>
                                              <td class="padding-top-4px padding-bottom-4px text-align-center padding-left-0px">
                                                {{l.DOC}}

                                              </td>
                                              <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">

                                                {{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}
                                              </td>
                                              <td class="padding-top-4px padding-bottom-4px"><label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label></td>

                                              <td class="padding-top-4px padding-bottom-4px">
                                                <label class="margin-bottom-0px" *ngIf="l.DOC!=='3'">{{l.CellStage}}</label>
                                                <label class="margin-bottom-0px" *ngIf="l.DOC=='3'">{{l.CellCount}}</label>
                                              </td>
                                              <td class="padding-top-4px padding-bottom-4px text-align-center">{{l.EmbryoCount}}</td>
                                              <!--<td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}}</td>-->
                                              <!--<td class="padding-top-4px padding-bottom-4px"><button class="btn actions-btn-prime font-size-13px margin-right-auto" (click)="SelectPresentstep1(l)">Select</button></td>-->
                                            </tr>
                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>







        </div>
      </div>

    </div>
    <div class="row" *ngIf="Showivf">
      <div class="col-md-12">
        <ivfworkbench></ivfworkbench>
      </div>
    </div>
    <router-outlet></router-outlet>
    <router-outlet name="print"></router-outlet>
  </div>
</div>
